import { ViewProps } from 'react-native';
import styled from 'styled-components/native';

interface Props extends ViewProps {
  count: number;
  active_index?: number;
}

export const IndicatorDots = ({ count, active_index, ...props }: Props) => (
  <Container {...props}>
    {[...Array(count)].map((_, idx) =>
      idx === active_index ? <ActiveDot key={idx} /> : <InactiveDot key={idx} />
    )}
  </Container>
);

const Container = styled.View`
  flex-direction: row;
  padding: 8px;
  gap: 8px;
  background-color: rgba(5.1, 21.85, 51, 0.05);
  border-radius: 100px;
`;

const ActiveDot = styled.View`
  height: 9px;
  width: 9px;
  border-radius: 40px;
  background-color: #051633;
`;

const InactiveDot = styled.View`
  height: 9px;
  width: 9px;
  border-radius: 40px;
  background-color: rgba(5.1, 21.85, 51, 0.15);
`;
